/* eslint-disable no-param-reassign */
import type { Data } from '../../specProcessor';
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as DoublePieLayerSpec } from '../../../../layer/preset/pie/doublePie';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

// 扩展ILayerTypeSpec以包含__isEncodingValid属性
interface DoublePieLayerTypeWithFields extends ILayerTypeSpec {
  __isEncodingValid?: boolean;
}

type DoublePieLayerType = StandardChartLayerSpec &
  DoublePieLayerSpec &
  DoublePieLayerTypeWithFields;

// 创建双饼图数据类型验证器
const validateDoublePieDataTypes = createDataTypeValidator('doublePie', [
  { field: 'x', type: 'string' },
  { field: 'y', type: 'number' },
  { field: 'x2', type: 'string' },
  { field: 'y2', type: 'number' }
]);

// 创建双饼图编码验证器
const validateDoublePieEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'x2' },
  { field: 'y2' }
]);

// 额外的检查函数 - 验证数据量是否符合建议
const additionalDoublePieChecks = (layer: DoublePieLayerType, data: Data) => {
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];

  // 检查总数据量是否超过建议的15条
  if (values.length > 15) {
    utils.logger.warn(
      'warning',
      `The "${layer.type}" chart works best with fewer than 15 data points for better readability`
    );
  }

  // 检查是否至少有2条数据
  if (values.length < 2) {
    utils.logger.warn(
      'warning',
      `The "${layer.type}" chart requires at least 2 data points to show distribution`
    );
  }
};

// 创建并导出双饼图处理器
export const doublePie = createLayerProcessor<DoublePieLayerType>(
  'doublePie',
  validateDoublePieEncoding,
  validateDoublePieDataTypes,
  additionalDoublePieChecks
);
